import { createSlice } from '@reduxjs/toolkit';
var sliceName = 'TUTORIAL';
var initialState = {
  activeTutorial: false,
  tutorialName: null,
  tutorialStep: 0,
  blockLobby: false,
  tutorialCompletedOrSkipped: false
};
var missionsTutorialSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    setTutorialStep: function setTutorialStep(state, action) {
      state.tutorialStep = action.payload;
      state.blockLobby = state.tutorialStep == 0 ? true : false;
    },
    setActiveTutorial: function setActiveTutorial(state, action) {
      var _action$payload$block, _action$payload$tutor, _action$payload$tutor2;
      state.activeTutorial = action.payload.activeTutorial;
      state.blockLobby = (_action$payload$block = action.payload.blockLobby) !== null && _action$payload$block !== void 0 ? _action$payload$block : action.payload.activeTutorial;
      state.tutorialName = (_action$payload$tutor = action.payload.tutorialName) !== null && _action$payload$tutor !== void 0 ? _action$payload$tutor : state.tutorialName;
      state.tutorialCompletedOrSkipped = (_action$payload$tutor2 = action.payload.tutorialCompletedOrSkipped) !== null && _action$payload$tutor2 !== void 0 ? _action$payload$tutor2 : state.tutorialCompletedOrSkipped;
    },
    cleanTutorialCompleted: function cleanTutorialCompleted(state) {
      state.tutorialCompletedOrSkipped = null;
    }
  }
});
var actions = missionsTutorialSlice.actions,
  reducer = missionsTutorialSlice.reducer;
var setTutorialStep = actions.setTutorialStep,
  setActiveTutorial = actions.setActiveTutorial,
  cleanTutorialCompleted = actions.cleanTutorialCompleted;
export { setTutorialStep, setActiveTutorial, cleanTutorialCompleted };
export default reducer;